import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English", flag: "🇬🇧", dir: "ltr" },
  { code: "es", label: "Spanish", native: "Español", flag: "🇪🇸", dir: "ltr" },
  { code: "fr", label: "French", native: "Français", flag: "🇫🇷", dir: "ltr" },
  { code: "pt", label: "Portuguese", native: "Português", flag: "🇵🇹", dir: "ltr" },
  { code: "de", label: "German", native: "Deutsch", flag: "🇩🇪", dir: "ltr" },
  { code: "it", label: "Italian", native: "Italiano", flag: "🇮🇹", dir: "ltr" },
  { code: "zh", label: "Chinese", native: "中文", flag: "🇨🇳", dir: "ltr" },
  { code: "ar", label: "Arabic", native: "العربية", flag: "🇸🇦", dir: "rtl" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
      de: { translation: de },
      it: { translation: it },
      zh: { translation: zh },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "mfr_lang",
    },
  });

const applyDir = (lng) => {
  const lang = LANGUAGES.find((l) => l.code === lng) || LANGUAGES[0];
  document.documentElement.setAttribute("lang", lang.code);
  document.documentElement.setAttribute("dir", lang.dir);
};

applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

export default i18n;
